import MFA from "@irati/auth/utils/mfa";
import isMFARequired, { isGraphMFARequired } from "./isMFARequired";
export { isMFARequired, isGraphMFARequired };
var inFlight = null;
export default function mfaTokenAndReplay(err) {
    if (!inFlight) {
        inFlight = showPopup();
    }
    return inFlight
        .then(function () {
        inFlight = null;
    })
        .catch(function () {
        inFlight = null;
        throw err;
    });
}
function showPopup() {
    return new Promise(function (resolve, reject) {
        MFA.start(resolve, reject);
    });
}
